import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";

import ShoppingCartItemsListItem from "./shoppingCartItemsListItem";
import {cartItemInterface} from "./cartItemInterface";
import AdvancedQuotingListItem from "./advancedQuoting/advancedQuotingListItem";


const ShoppingCartItemsBundledProducts = (props) => {

  const {parentCartItem, cartItems, fabricatorData, isMobile, isAdvancedMode, advancedModeProperties} = props;
  const fabricatorSettings = fabricatorData.settings;

  const bundledCartItems = cartItems.filter(cItem => cItem.bundleParentId === parentCartItem.id);

  return (
    <div className="scart-block__bundled">
      <div className="scart-block__bundled-top">
        <FormattedMessage id="shoppingCart.bundledItems"/>
      </div>
      <ul className={"scart-block__list"
        + (fabricatorSettings.showPricing && !fabricatorData.hideCheckoutBreakdownCost
        && !fabricatorData.hidePricesFromUser && !isMobile ? " scart-block__list--with-price" : "")}>
        {bundledCartItems.map(cartItem => {
          if (isAdvancedMode) {
            return <AdvancedQuotingListItem cartItem={cartItem}
                                            key={cartItem.id}
                                            {...advancedModeProperties}
                                            isBundleChild={true}/>
          }
          return <ShoppingCartItemsListItem cartItem={cartItem}
                                            key={cartItem.id}
                                            editFeatureGroupClick={() => null}
                                            isBundleChild={true}/>
        })}
      </ul>
    </div>
  )
};

ShoppingCartItemsBundledProducts.propTypes = {
  parentCartItem: PropTypes.shape(cartItemInterface).isRequired,
}

const mapStateToProps = (store) => {
  const {cartItems} = store.cartState;
  const {isMobile} = store.serverState;

  return {
    cartItems,
    fabricatorData: store.fabricatorState,
    isMobile,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingCartItemsBundledProducts)

